import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'facebookAnalyticsKey',
  initialState: null as null | string,
  reducers: {
    setFacebookAnalyticsKey(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setFacebookAnalyticsKey } = slice.actions;

export default slice.reducer;
